import { storableError } from '../../util/errors';
import { fetchCurrentUser, loadUserSubscriptions } from '../../ducks/user.duck';
import {
  fetchAllSubscriptionsApi,
  createSubscriptionApi,
  updateSubscriptionApi,
  cancelSubscriptionApi,
  fetchAllTokenpackageApi,
  createPaymentIntentApi,
  updateUserInPipedriveApi
} from '../../util/api';
import { stripeCustomer } from '../CheckoutPage/CheckoutPage.duck';
import { TOKEN_PACKAGE } from '../../util/types';
import { ACTIVE_TIER } from '../../util/pipeDriveKeys';

// ================ Action types ================ //

export const FETCH_SUBSCRIPTIONS_REQUEST = 'app/SubscriptionCheckoutPage/FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'app/SubscriptionCheckoutPage/FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_ERROR = 'app/SubscriptionCheckoutPage/FETCH_SUBSCRIPTIONS_ERROR';

export const CREATE_SUBSCRIPTION_REQUEST = 'app/SubscriptionCheckoutPage/CREATE_SUBSCRIPTION_REQUEST';
export const CREATE_SUBSCRIPTION_SUCCESS = 'app/SubscriptionCheckoutPage/CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_ERROR = 'app/SubscriptionCheckoutPage/CREATE_SUBSCRIPTION_ERROR';

export const UPDATE_SUBSCRIPTION_REQUEST = 'app/SubscriptionCheckoutPage/UPDATE_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'app/SubscriptionCheckoutPage/UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_ERROR = 'app/SubscriptionCheckoutPage/UPDATE_SUBSCRIPTION_ERROR';

export const CANCEL_SUBSCRIPTION_REQUEST = 'app/SubscriptionCheckoutPage/CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'app/SubscriptionCheckoutPage/CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_ERROR = 'app/SubscriptionCheckoutPage/CANCEL_SUBSCRIPTION_ERROR';

export const FETCH_TOKEN_PACKAGES_REQUEST = 'app/SubscriptionCheckoutPage/FETCH_TOKEN_PACKAGES_REQUEST';
export const FETCH_TOKEN_PACKAGES_SUCCESS = 'app/SubscriptionCheckoutPage/FETCH_TOKEN_PACKAGES_SUCCESS';
export const FETCH_TOKEN_PACKAGES_ERROR = 'app/SubscriptionCheckoutPage/FETCH_TOKEN_PACKAGES_ERROR';

export const CREATE_TOKEN_PAYMENT_INTENT_REQUEST = 'app/SubscriptionCheckoutPage/CREATE_TOKEN_PAYMENT_INTENT_REQUEST';
export const CREATE_TOKEN_PAYMENT_INTENT_SUCCESS = 'app/SubscriptionCheckoutPage/CREATE_TOKEN_PAYMENT_INTENT_SUCCESS';
export const CREATE_TOKEN_PAYMENT_INTENT_ERROR = 'app/SubscriptionCheckoutPage/CREATE_TOKEN_PAYMENT_INTENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  subscriptions: null,
  tokenPackages: null,
  createInProgress: false,
  createError: null,
  createdSubscription: null,
  updateInProgress: false,
  updateError: null,
  updatedSubscription: null,
  cancelInProgress: false,
  cancelError: null,
  canceledSubscription: null,

  fetchTokensInProgress: false,
  fetchTokensError: null,
  tokenPackages: null,

  createTokenPaymentIntentInProgress: false,
  createTokenPaymentIntentError: null,
  tokenPaymentIntent: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUBSCRIPTIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null, tokenPackages: null };
    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return { ...state, fetchInProgress: false, subscriptions: payload?.data, fetchError: null };
    case FETCH_SUBSCRIPTIONS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    case CREATE_SUBSCRIPTION_REQUEST:
      return { ...state, createInProgress: true, createError: null };
    case CREATE_SUBSCRIPTION_SUCCESS:
      return { ...state, createInProgress: false, createdSubscription: payload, createError: null };
    case CREATE_SUBSCRIPTION_ERROR:
      return { ...state, createInProgress: false, createError: payload };
    case UPDATE_SUBSCRIPTION_REQUEST:
      return { ...state, updateInProgress: true, updateError: null };
    case UPDATE_SUBSCRIPTION_SUCCESS:
      return { ...state, updateInProgress: false, updatedSubscription: payload, updateError: null };
    case UPDATE_SUBSCRIPTION_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };
    case CANCEL_SUBSCRIPTION_REQUEST:
      return { ...state, cancelInProgress: true, cancelError: null };
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return { ...state, cancelInProgress: false, canceledSubscription: payload, cancelError: null };
    case CANCEL_SUBSCRIPTION_ERROR:
      return { ...state, cancelInProgress: false, cancelError: payload };
    case FETCH_TOKEN_PACKAGES_REQUEST:
      return { ...state, fetchTokensInProgress: true, fetchTokensError: null, tokenPackages: null, subscriptions: null };
    case FETCH_TOKEN_PACKAGES_SUCCESS:
      return { ...state, fetchTokensInProgress: false, tokenPackages: payload?.data, fetchTokensError: null };
    case FETCH_TOKEN_PACKAGES_ERROR:
      return { ...state, fetchTokensInProgress: false, fetchTokensError: payload };
    case CREATE_TOKEN_PAYMENT_INTENT_REQUEST:
      return { ...state, createTokenPaymentIntentInProgress: true, createTokenPaymentIntentError: null };
    case CREATE_TOKEN_PAYMENT_INTENT_SUCCESS:
      return { ...state, createTokenPaymentIntentInProgress: false, tokenPaymentIntent: payload, createTokenPaymentIntentError: null };
    case CREATE_TOKEN_PAYMENT_INTENT_ERROR:
      return { ...state, createTokenPaymentIntentInProgress: false, createTokenPaymentIntentError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchSubscriptionsRequest = () => ({ type: FETCH_SUBSCRIPTIONS_REQUEST });
export const fetchSubscriptionsSuccess = data => ({ type: FETCH_SUBSCRIPTIONS_SUCCESS, payload: data });
export const fetchSubscriptionsError = e => ({ type: FETCH_SUBSCRIPTIONS_ERROR, payload: e, error: true });

export const createSubscriptionRequest = () => ({ type: CREATE_SUBSCRIPTION_REQUEST });
export const createSubscriptionSuccess = data => ({ type: CREATE_SUBSCRIPTION_SUCCESS, payload: data });
export const createSubscriptionError = e => ({ type: CREATE_SUBSCRIPTION_ERROR, payload: e, error: true });

export const updateSubscriptionRequest = () => ({ type: UPDATE_SUBSCRIPTION_REQUEST });
export const updateSubscriptionSuccess = data => ({ type: UPDATE_SUBSCRIPTION_SUCCESS, payload: data });
export const updateSubscriptionError = e => ({ type: UPDATE_SUBSCRIPTION_ERROR, payload: e, error: true });

export const cancelSubscriptionRequest = () => ({ type: CANCEL_SUBSCRIPTION_REQUEST });
export const cancelSubscriptionSuccess = data => ({ type: CANCEL_SUBSCRIPTION_SUCCESS, payload: data });
export const cancelSubscriptionError = e => ({ type: CANCEL_SUBSCRIPTION_ERROR, payload: e, error: true });

export const fetchTokenPackagesRequest = () => ({ type: FETCH_TOKEN_PACKAGES_REQUEST });
export const fetchTokenPackagesSuccess = data => ({ type: FETCH_TOKEN_PACKAGES_SUCCESS, payload: data });
export const fetchTokenPackagesError = e => ({ type: FETCH_TOKEN_PACKAGES_ERROR, payload: e, error: true });

export const createTokenPaymentIntentRequest = () => ({ type: CREATE_TOKEN_PAYMENT_INTENT_REQUEST });
export const createTokenPaymentIntentSuccess = data => ({ type: CREATE_TOKEN_PAYMENT_INTENT_SUCCESS, payload: data });
export const createTokenPaymentIntentError = e => ({ type: CREATE_TOKEN_PAYMENT_INTENT_ERROR, payload: e, error: true });

// ================ Thunks ================ //

export const onFetchSubscriptions = (subscriptionId) => (dispatch, getState, sdk) => {
  dispatch(fetchSubscriptionsRequest());
  return fetchAllSubscriptionsApi({ subscriptionId })
    .then(subscriptions => {
      dispatch(fetchSubscriptionsSuccess(subscriptions));
      return subscriptions;
    })
    .catch(e => {
      dispatch(fetchSubscriptionsError(storableError(e)));
      throw e;
    });
};

export const onFetchTokenPackages = (packageId) => (dispatch, getState, sdk) => {
  dispatch(fetchTokenPackagesRequest());
  return fetchAllTokenpackageApi({ id: packageId })
    .then(packages => {
      dispatch(fetchTokenPackagesSuccess(packages));
      return packages;
    })
    .catch(e => {
      dispatch(fetchTokenPackagesError(storableError(e)));
      throw e;
    });
};

export const onCreateSubscription = (values, pipeDriveUserId) => (dispatch, getState, sdk) => {
  dispatch(createSubscriptionRequest());
  return createSubscriptionApi({ ...values, pipeDriveUserId })
    .then(subscription => {
      dispatch(createSubscriptionSuccess(subscription));
      const updates = {
        [ACTIVE_TIER]: values?.selectedSubscription?.planType,
      };
      updateUserInPipedriveApi({ updates, pipeDriveUserId })
      return subscription;
    })
    .catch(e => {
      dispatch(createSubscriptionError(storableError(e)));
      throw e;
    });
};

export const onUpdateSubscription = (values, pipeDriveUserId) => (dispatch, getState, sdk) => {
  dispatch(updateSubscriptionRequest());
  return updateSubscriptionApi(values)
    .then(subscription => {
      dispatch(updateSubscriptionSuccess(subscription));
      const updates = {
        [ACTIVE_TIER]: values?.selectedSubscription?.planType,
      };
      updateUserInPipedriveApi({ updates, pipeDriveUserId })
      return subscription;
    })
    .catch(e => {
      dispatch(updateSubscriptionError(storableError(e)));
      throw e;
    });
};

export const onCancelSubscription = values => (dispatch, getState, sdk) => {
  dispatch(cancelSubscriptionRequest());
  return cancelSubscriptionApi({ ...values })
    .then(subscription => {
      dispatch(cancelSubscriptionSuccess(subscription));
      dispatch(loadUserSubscriptions({ userId: values?.userId }))
      return subscription;
    })
    .catch(e => {
      dispatch(cancelSubscriptionError(storableError(e)));
      throw e;
    });
};

export const fetchTokenPackageData = (params) => (dispatch, getState, sdk) => {
  const { packageId } = params || {};

  dispatch(fetchSubscriptionsRequest());
  return dispatch(fetchCurrentUser())
    .then(() => {
      const currentUser = getState().user.currentUser;
      const userId = currentUser?.id?.uuid;

      if (!userId) {
        throw new Error('User ID not found');
      }

      // dispatch(loadUserSubscriptions({ userId: currentUser?.id?.uuid }))
      dispatch(onFetchTokenPackages(packageId));
      dispatch(stripeCustomer())
      return {};
    })
    .catch(e => {
      dispatch(fetchSubscriptionsError(storableError(e)));
      throw e;
    });

};

export const fetchSubscriptionData = (params) => (dispatch, getState, sdk) => {
  const { packageId } = params || {};
  dispatch(fetchSubscriptionsRequest());
  return dispatch(fetchCurrentUser())
    .then(() => {
      const currentUser = getState().user.currentUser;
      const userId = currentUser?.id?.uuid;

      if (!userId) {
        throw new Error('User ID not found');
      }

      dispatch(loadUserSubscriptions({ userId: currentUser?.id?.uuid }))
      dispatch(onFetchSubscriptions(packageId));
      dispatch(stripeCustomer())
      return {};
    })
    .catch(e => {
      dispatch(fetchSubscriptionsError(storableError(e)));
      throw e;
    });

};

export const createTokensPaymentIntent = (params) => (dispatch, getState, sdk) => {
  dispatch(createTokenPaymentIntentRequest());
  return createPaymentIntentApi({ ...params })
    .then(response => {
      dispatch(createTokenPaymentIntentSuccess(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(createTokenPaymentIntentError(error));
      throw error;
    });
};

// ================ Load data ================ //

export const loadData = params => (dispatch, getState, sdk) => {
  const { type } = params || {};
  if (type == TOKEN_PACKAGE) {
    return dispatch(fetchTokenPackageData(params));
  } else {
    return dispatch(fetchSubscriptionData(params));
  }
}; 